/**
 * LSA (Local Services Ads) sidebar configuration
 */
export default {
  pathPrefix: 'lsa',
  items: [
    {
      label: 'Campaigns',
      href: '/lsa/dashboard',
      icon: 'fa-solid fa-chart-mixed',
      activePath: 'lsa/dashboard'
    },
    {
      label: 'Leads',
      href: '/lsa/leads',
      icon: 'fa-solid fa-address-book',
      activePath: 'lsa/leads'
    },
    {
      label: 'Bid Estimator',
      href: '/lsa/bid_estimator',
      icon: 'fa-solid fa-calculator',
      activePath: 'lsa/bid_estimator'
    },
    {
      label: 'Launch Agent',
      href: '/lsa/launch_agent',
      icon: 'fa-solid fa-rocket',
      activePath: 'lsa/launch_agent'
    },
    {
      label: 'AI Agents',
      href: '/lsa/agents',
      icon: 'fa-solid fa-robot',
      activePath: 'lsa/agents',
      show: (store) => store.user.adminPrivileges
    },
    {
      label: 'Settings',
      href: '/lsa/settings',
      icon: 'fa-solid fa-gear',
      activePath: 'lsa/settings',
      show: (store) => store.user.adminPrivileges
    }
  ]
}
